import React from 'react';
import Icon from './Icon';

const CheckCircleIcon = (props) => (
    <Icon {...props}>
        <path
            d="M8.5 12.5L11 15L16 9.5M9.5 2.4A10 10 0 1 1 2.4 9.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default CheckCircleIcon;
